import React, {lazy, Suspense} from 'react';
import { HashRouter as Router, Route, Redirect } from 'react-router-dom';

import {
  isLoggedin,
  isIFRAMEUrl,
  isPartnerURL,
  isONLYPC,
  defineTypeCase,
  definePartner,
  defineFilter
} from 'Root/utils';
import {
  showNavbar,
  showSidebar,
  showAppsflyer,
  showBgGradient,
  showFloatButton,
  showCustomFloatButton
} from 'Root/constants';
import {
  Home,
  Login,
  VirtualMirror,
  Quiz,
  LensCare,
  InstagramTemplate,
  CookiePolicy
} from 'Root/pages';
import Navbar from 'Components/navbar';
import Footer from 'Components/footer';
import Context from 'Components/context';
const Sidebar = lazy(() => import('Components/sidebar'));
import { CustomQuiz } from 'Components/quiz';
import DownloadLookTutorialPdf from 'Components/virtualMirror/Tutorial/LooksTutorial/DownloadLookTutorialPdf';
const BgGradient = lazy(() => import('Components/commonComponents/bgGradient'));
const Tolstoy = lazy(() => import('Components/tolstoy'));
const Appsflyer = lazy(() => import('Components/helper/Appsflyer'));
const FloatButton = lazy(() => import('Components/floatButton'));
const CustomFloatButton = lazy(() => import('Components/customFloatButton'));
// const CookiePolicyFooter = lazy(() => import('Components/cookiePolicy/cookiePolicyFooter'));
import CookiePolicyFooter from 'Components/cookiePolicy/cookiePolicyFooter';

import 'Sass/components/content.scss';

// -----------------Todo-------------------
// Fix the directory structure and move all components files accordingly
// Move all constants and process.env to Utils.js
// Break CSS at component Level & move to respective directories
// Remove ternatory operators from JSX
// Convert all yes-no to true-false
// Don't pass context as props

const PrivateRoute = ({ component: Component, context, close, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedin() ? (
          <Component {...props} close={close} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

const NoAuthRoute = ({ component: Component, close, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedin() ? <Redirect to="/home" /> : <Component {...props} />
      }
    />
  );
};

const PublicRoute = ({ component: Component, close, ...rest }) => {
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};

const SHOW_QUIZ = process.env.REACT_APP_SHOW_QUIZ;
const CUSTOM_QUIZ = process.env.REACT_APP_CUSTOM_QUIZ || 'no';
const SHOW_KAIZEN = process.env.REACT_APP_SHOW_KAIZEN || 'no';
const KAIZEN_LINK = process.env.REACT_APP_KAIZEN_LINK || '';
const SHOW_COOKIE_POLICY = process.env.REACT_APP_SHOW_COOKIE_POLICY || 'no';
const SHOW_TOLSTOY = process.env.REACT_APP_SHOW_TOLSTOY || 'no';

const ContentClass = () => {
  let content_class = 'content--page';
  if(isIFRAMEUrl()) {
    content_class += ' iframe-url';
    if(isONLYPC()) {
      content_class += ' only-pc';
    }
    if(defineTypeCase()) {
      content_class += ' type-' + defineTypeCase();
    }
    if(defineFilter()) {
      content_class += ' filter-' + defineFilter();
    }
  }
  if(isPartnerURL()) {
    content_class += ' partner-' + definePartner();
  }
  return content_class;
};

const allowOneTrustSettings = (callback) => {
  setTimeout(() => {
    Optanon.AllowAll();
    callback();
  }, 500)
}

const openOneTrustBanner = (callback) => {
  setTimeout(() => {
    if(document.getElementById('onetrust-consent-sdk')) {
      document.getElementById('onetrust-consent-sdk').style='display:none!important;';
      Optanon.ToggleInfoDisplay();
      callback();
    }
  }, 5000)
}

export default class Routing extends React.Component {
  state = {
    closeVM: false,
  };

  componentDidMount() {
    if (SHOW_KAIZEN === 'yes') {
      const script = document.createElement('script');
      script.src = KAIZEN_LINK;
      script.async = true;
      document.body.appendChild(script);
    }
    if (SHOW_COOKIE_POLICY === 'yes') {
      const cookiePolicyScript = document.createElement('script');
      cookiePolicyScript.src = process.env.REACT_APP_COOKIE_POLICY_LINK;
      cookiePolicyScript.setAttribute('charset', 'UTF-8');
      cookiePolicyScript.setAttribute('data-domain-script', process.env.REACT_APP_COOKIE_POLICY_KEY);
      cookiePolicyScript.setAttribute('data-document-language','true');
      document.body.appendChild(cookiePolicyScript);
      const cookiePolicyInlineScript = document.createElement('script');
      cookiePolicyInlineScript.type='text/javascript';
      cookiePolicyInlineScript.innerHTML = 'function OptanonWrapper() { }';
      document.body.appendChild(cookiePolicyInlineScript);

      // if(isIFRAMEUrl()) {
      //   openOneTrustBanner(function(){
      //     allowOneTrustSettings(function(){
      //       setTimeout(() => {
      //         document.getElementById('onetrust-consent-sdk').style='display:block!important;';
      //       }, 500);
      //     })
      //   });
      // }
    }
  }

  handleHomeClick() {
    this.setState({ closeVM: true });

    // added to fix bug, vm box closes again n again
    const timer = setTimeout(() => {
      this.setState({ closeVM: false });
      clearTimeout(timer);
    }, 1000);
  }

  render() {
    return (
      <div className={ContentClass()}>
        {showBgGradient && !isIFRAMEUrl() && (
          <Suspense fallback={<div></div>}>
            <BgGradient />
          </Suspense>
        )}
        <Context.Consumer>
          {(context) => (
            <Router hashType="slash">
            {
              showAppsflyer && isLoggedin() && !isIFRAMEUrl() && (
                <Suspense fallback={<div></div>}>
                  <Appsflyer/>
                </Suspense>
              )
            }
              {showNavbar && isLoggedin() && !isIFRAMEUrl() && (
                <Navbar
                    onHomeClick={this.handleHomeClick.bind(this)}
                    product={context.product}
                />
              )}
              {
                showCustomFloatButton && isPartnerURL() ? (
                  <Suspense fallback={<div></div>}>
                    <CustomFloatButton />
                  </Suspense>
                ) : showFloatButton ? 
                (
                  <Suspense fallback={<div></div>}>
                    <FloatButton />
                  </Suspense>
                ) : null
              }
              {showFloatButton && isLoggedin() && !isIFRAMEUrl() && (
                <Suspense fallback={<div></div>}>
                  <FloatButton />
                </Suspense>
              )}
              <main className="content--main">
                {showSidebar && !isIFRAMEUrl() && (
                  <Suspense fallback={<div></div>}>
                    <Sidebar
                      onHomeClick={this.handleHomeClick.bind(this)}
                      product={context.product}
                    />
                  </Suspense>
                )}
                <section className="content--component">
                  <NoAuthRoute path="/" exact component={Login} />
                  <NoAuthRoute path="/login" exact component={Login} />
                  <PublicRoute
                    path="/looks/download/:lookName/:lensName"
                    exact
                    component={DownloadLookTutorialPdf}
                  />
                  {CUSTOM_QUIZ === 'yes' ? (
                    <PrivateRoute
                      path="/quiz"
                      context={context}
                      exact
                      component={CustomQuiz}
                    />
                  ) : SHOW_QUIZ === 'yes' ? (
                    <PrivateRoute
                      path="/quiz"
                      context={context}
                      exact
                      component={Quiz}
                      close={this.state.closeVM}
                    />
                  ) : null}
                  <PrivateRoute
                    path="/vm"
                    exact
                    context={context}
                    component={VirtualMirror}
                    close={this.state.closeVM}
                    product={context.product}
                    look={context.look}
                    makeup={context.makeup}
                  />
                  {/* {SHOW_QUIZ === 'yes' && CUSTOM_QUIZ === 'no' && (
                    <PrivateRoute
                      path="/vm/:recommendation"
                      exact
                      context={context}
                      component={VirtualMirror}
                      close={this.state.closeVM}
                      product={context.product}
                      look={context.look}
                      makeup={context.makeup}
                    />
                  )} */}
                  {/* {SHOW_QUIZ === 'yes' && CUSTOM_QUIZ === 'yes' && ( */}
                  <PrivateRoute
                    path="/vm/:result"
                    exact
                    context={context}
                    component={VirtualMirror}
                    close={this.state.closeVM}
                    product={context.product}
                    look={context.look}
                    makeup={context.makeup}
                  />
                  {/* )} */}
                  <PrivateRoute
                    path="/home"
                    component={Home}
                    context={context}
                  />
                  <PrivateRoute
                    path="/about-lens-care"
                    component={LensCare}
                    context={context}
                  />
                  <PrivateRoute
                    path="/photo-filter"
                    component={InstagramTemplate}
                    context={context}
                  />
                  { SHOW_COOKIE_POLICY === 'yes' && ( 
                    <PrivateRoute
                      path="/cookie-policy"
                      component={CookiePolicy}
                      context={context}
                    />
                  )}
                </section>
              </main>
              { SHOW_COOKIE_POLICY === 'yes' && (
                  (isLoggedin() && !isIFRAMEUrl()) ? <CookiePolicyFooter/> : null
                )
              }
              {SHOW_TOLSTOY === 'yes' && !isIFRAMEUrl() && (
                <Suspense fallback={<div></div>}>
                  <Tolstoy />
                </Suspense>
               )}
              {!isLoggedin() || (isIFRAMEUrl() && defineTypeCase() !== 'six') ? null : <Footer/>}
            </Router>
          )}
        </Context.Consumer>
      </div>
    );
  }
}
